<template>
  <section class="lesson-understood-buttons">
    <h1 class="lesson-understood-heading">
      {{ $t('components.lesson-understood-buttons.heading') }}
    </h1>
    <div class="lesson-understood-button-wrapper" ref="buttons">
      <button
        v-for="button in buttonData"
        :key="button.understood"
        type="button"
        class="lesson-understood-button"
        :class="[
          button.className,
          { selected: button.understood === understoodStatus },
        ]"
        @click="onSetUnderstood(button.understood)"
      >
        <span class="icon-circle">
          <FaIcon :icon="button.icon" />
        </span>
        <span class="button-label">
          {{ button.text }}
        </span>
      </button>
    </div>
  </section>
</template>

<script>
import FaIcon from '../ui/FaIcon'
import { LessonUnderstood } from '@/enums'
import { LessonStoreNamespacedTypes } from '@/store/lessons'

export default {
  name: 'LessonUnderstoodButtons',
  components: { FaIcon },
  props: {
    lessonId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      LessonUnderstood,
      buttonData: [
        {
          className: 'understood-button-yes',
          icon: 'thumbs-up',
          text: this.$t('components.lesson-understood-buttons.yes-button'),
          understood: LessonUnderstood.YES,
        },
        {
          className: 'understood-button-somewhat',
          icon: 'thumbs-up',
          text: this.$t('components.lesson-understood-buttons.somewhat-button'),
          understood: LessonUnderstood.SOMEWHAT,
        },
        {
          className: 'understood-button-no',
          icon: 'thumbs-down',
          text: this.$t('components.lesson-understood-buttons.no-button'),
          understood: LessonUnderstood.NO,
        },
      ],
    }
  },
  computed: {
    /**
     * Returns the understood status from the lesson store
     */
    understoodStatus() {
      return this.$store.getters[
        LessonStoreNamespacedTypes.getters.GET_UNDERSTOOD_STATUS
      ](this.lessonId)
    },
  },
  methods: {
    /**
     * Submits (post) the understood status along with the lesson id. When success it emits a change event.
     * @param {LessonUnderstood} understood
     * @emits change
     */
    onSetUnderstood(understood) {
      const lessonId = this.lessonId

      this.$store
        .dispatch(LessonStoreNamespacedTypes.actions.SUBMIT_UNDERSTOOD_STATUS, {
          lessonId,
          understood,
        })
        .then(() => {
          this.$emit('change', { lessonId, understood })
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.lesson-understood-heading {
  font-size: 1.833em;
  text-align: center;
}

.lesson-understood-button-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

.lesson-understood-button {
  background: transparent;
  border: transparent;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: opacity $transitionFast;
  box-shadow: none;

  &.selected,
  &.selected:focus:not(:focus-visible) {
    box-shadow: none;
  }

  &:not(.selected) {
    opacity: 0.3;

    &:hover {
      opacity: 0.6;
    }
  }

  &:hover {
    text-decoration: underline;
    background: none;
  }
}

.icon-circle {
  display: flex;
  width: 5em;
  height: 5em;
  align-items: center;
  justify-content: center;
  border-radius: 100%;

  > .fa-icon {
    font-size: 2.5em;
    color: $white;
  }
}

.button-label {
  background: $white;
  border: 1px solid #ccd;
  border-radius: $borderRadiusSmall;
  padding: 0.25em 0.75em;
  margin-top: -0.5em;
  min-width: 3em;
}

.understood-button-yes {
  .icon-circle {
    background-color: $green;
  }
}
.understood-button-somewhat {
  .icon-circle {
    background-color: $orange;
  }

  .fa-icon {
    transform: rotate(-90deg) translateY(-3%);
  }
}
.understood-button-no {
  .icon-circle {
    background-color: $red;
  }
}
</style>
